import type { PersistedUser } from "@/entities/user/types/user";
import type { EntityServiceResponseError } from "@/services/blackfisk";

import { blackfiskAxiosRequest } from "@/services/blackfisk";

// # User

export async function userList(
  userId = 0,
  forceRefresh = false,
): Promise<{
  errors: EntityServiceResponseError[];
  users: PersistedUser[];
  cached: boolean;
}> {
  const { errors, data, cached } = await blackfiskAxiosRequest<PersistedUser[]>(
    {
      method: "get",
      url: "/v2/blackfisk/user",
      params: {
        userId,
        ...(forceRefresh && { ts: +new Date() }),
      },
    },
    (response) => {
      return response.data;
    },
  );
  return {
    errors,
    users: data || [],
    cached,
  };
}
